// Monthly leaderboard prize tables. The pool went from $40K to $50K starting with
// the Oct 24 2026 period (midnight BST = 2026-10-23 23:00 UTC). Keep in sync with
// MONTHLY_PRIZES_* in backend/server.js.
export const MONTHLY_POOL_50K_FROM = Date.parse('2026-10-23T23:00:00Z');

const toTable = (amounts) => amounts.map((prize, i) => ({ rank: i + 1, prize }));

export const MONTHLY_PRIZES_40K = toTable([10000, 7000, 4500, 3500, 3000, 2500, 2000, 1750, 1500, 1200, 1000, 750, 600, 400, 300]);
export const MONTHLY_PRIZES_50K = toTable([12500, 8500, 6000, 4500, 3500, 3000, 2500, 2250, 1750, 1500, 1200, 1000, 800, 600, 400]);

const is50k = (now) => now >= MONTHLY_POOL_50K_FROM;

export const getMonthlyPrizes = (now = Date.now()) => is50k(now) ? MONTHLY_PRIZES_50K : MONTHLY_PRIZES_40K;
// "$50,000" / "$40,000"
export const monthlyPoolLabel = (now = Date.now()) => is50k(now) ? '$50,000' : '$40,000';
// "$50K" / "$40K"
export const monthlyPoolShort = (now = Date.now()) => is50k(now) ? '$50K' : '$40K';
